module.exports = __webpack_public_path__ + "img/mv.192e0761.svg";